import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import FormInput from '../../form/FormInput';

const StepAddress = ({ control, errors, handlePincodeLookup,setValue }) => (
    <div className="animate-fade-in">
        <div className="form-section-title">Address</div>
        <Row>
            <Controller name="addressType" control={control} render={({ field }) => <input type="hidden" {...field} />} />
            <Col md={4}><FormInput name="addressLine1" label="Address Line 1" control={control} errors={errors}  /></Col>
            <Col md={4}><FormInput name="state" label="State" control={control} errors={errors}  /></Col>
            <Col md={4}><FormInput name="district" label="District" control={control} errors={errors}  /></Col>
            
            <Col md={4}>
                {/* FormInput now correctly expects customOnChange */}
                <FormInput 
                    name="pinCode" 
                    label="Pin Code" 
                    control={control} 
                    errors={errors} 
                     
                    maxLength={6}
                    customOnChange={(e) => {
                        const value = e.target.value;
                        // control.setValue('pinCode', value, { shouldValidate: true }); // Use control.setValue
                    setValue('pinCode', value, { shouldValidate: true }); // Use control.setValue

                        if (value.length === 6) handlePincodeLookup(value);
                    }}
                />
            </Col>
        </Row>
        <Row>
            <Col md={6}><FormInput name="addressLine2" label="Address Line 2" control={control} errors={errors} hidden /></Col>
        </Row>
    </div>
);

export default StepAddress;